<template>
  <i @mouseover="showTooltip(speechCraftCode)">
    <arb-basic-tooltips :position="position" :maxWidth="maxWidth">
      <i class="fad fa-lightbulb text-warning light-size" slot="tip-icon"></i>
      <div v-html="toolTipData" slot="tip-content"></div>
    </arb-basic-tooltips>
  </i>
</template>

<script>
export default {
  name: 'arb-bulb-tooltips',
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    maxWidth: {
      type: String,
      default: '800px'
    },
    toolTipData: {
      type: String
    },
    speechCraftCode: {
      type: String
    }
  },
  methods: {
    showTooltip (speechCraftCode) {
      this.$eventBus.$emit('showTooltips', speechCraftCode)
    }
  }
}
</script>
<style scoped>
.light-size {
  font-size: 16px;
}
</style>
